export default __webpack_public_path__ + "static/media/sneakerNFTBg4.7639f4e9.png";